export var MemberMailerFrequency;
(function(MemberMailerFrequency) {
    MemberMailerFrequency[/**
     * Member does not want to receive promotional material.
     *
     * @remarks
     * Known as `null` in Vista Loyalty.
     */ "Never"] = "Never";
    MemberMailerFrequency[/**
     * Member will receive a mailer every week.
     */ "Weekly"] = "Weekly";
    MemberMailerFrequency[/**
     * Member will receive a mailer every two weeks.
     */ "Fortnightly"] = "Fortnightly";
    MemberMailerFrequency[/**
     * Member will receive a mailer every month.
     */ "Monthly"] = "Monthly";
})(MemberMailerFrequency || (MemberMailerFrequency = {}));

//# sourceMappingURL=member-mailer-frequency.js.map